import { mapGetPeriodResponse } from "features/LoyaltyPackage/data/apiAdapters";
import { formatProductMilestoneSummary, mapPeriodProductsToForm } from "features/LoyaltyPackage/core/utils";

/**
 * FE domain periodProducts → bảng SP màn Chi tiết (có discountSummary).
 * mapPeriodProductsToForm không giữ `productAwards` (chỉ dành cho Form — ăn theo mốc cha sống);
 * Detail là read-only nên phải gắn lại `productAwards` gốc để hiển thị đúng số mốc đã lưu của từng SP,
 * kể cả khi khác số lượng mốc hiện tại ở Section B.
 */
export function mapProductsForPackageDetail(periodProducts, milestones) {
  return mapPeriodProductsToForm(periodProducts, milestones).map((product, index) => {
    const withAwards = { ...product, productAwards: periodProducts?.[index]?.productAwards ?? null };
    return {
      ...withAwards,
      discountSummary: formatProductMilestoneSummary(withAwards, milestones, { requireAllFilled: false }),
    };
  });
}

/** Period đã map (hook) → dữ liệu hiển thị màn Chi tiết gói */
export function buildPackageDetailView(period, { periodProducts } = {}) {
  const milestones = period?.milestones ?? [];
  const resolvedProducts = periodProducts ?? period?.periodProducts ?? [];
  const products = mapProductsForPackageDetail(resolvedProducts, milestones);

  return { period, milestones, products };
}

/** Raw GetPeriod Apollo response → dữ liệu hiển thị (dùng test + debug pipeline đầy đủ) */
export function buildPackageDetailViewFromGetPeriod(apolloData) {
  const period = mapGetPeriodResponse(apolloData);
  return buildPackageDetailView(period);
}
